// extracted by mini-css-extract-plugin
export default {"input-label":"components-settings-competitors-modal-add-competitor-module__input-label"};